import { jQuery as $ } from 'lib/shim';

const SELECTOR = '.organism-product-intro';

class OrganismProductIntro {
	constructor(app, $element){
		if( !$.isSet($element.dataDuo('primed')) ){
			$element.dataDuo('primed', true);

			this._app = app;
			this._id = $.randomUuid(true);
			this._$element = $element;

			this._$slider = this._$element.find('.image-slider').first();

			this._refreshCallbacks = [];

			this._prime();
		}

		return $element;
	}



	_prime() {
		this._$slider
			.on('init', () => {
				this._$slider.removeClass('cloaked');
			})
			.slick({
				infinite : true,
				pauseOnHover : true,
				pauseOnFocus : true,
				pauseOnDotsHover : true,
				autoplay : true,
				autoplaySpeed : 6000,
				appendDots : this._$slider,
				dots : true,
				arrows : false,
				mobileFirst: true,
				slidesToShow: 1,
				slidesToScroll: 1
			})
		;

		this._app.registerResizeCallback(NAME+'-resize-'+this._id, () => {
			waitForRepaint(() => {
				_.each(this._refreshCallbacks, (cb) => { cb(); });
			});
		});
		waitForRepaint(() => {
			_.each(this._refreshCallbacks, (cb) => { cb(); });
		});
	}
}

export function init(app){
	let $elements = $();

	$(SELECTOR).each(function(){
		let $this = $(this);

		$elements = $elements.add(new OrganismProductIntro(app, $this));
	});

	return $elements;
}
